import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentActor } from 'src/app/models/actors';
import { ViewerDataService } from '../../viewer-data.service';
import { DocumentApiClient } from 'src/app/services/document.apiclient';
import { DocumentForDownloadModel } from 'src/app/models/api/document-for-download.model';
import { DownloadService } from 'src/app/services/download.service';
import { ViewerHubService } from 'src/app/services/viewerhub.service';
import { Subscription } from 'rxjs';
@Component({
  templateUrl: './perform-action-all-done.modal.html'
})
export class PerformActionAllDoneModal {

  @Input() expireDateAsString!: string;
  @Output('DownloadRequest') DownloadRequest = new EventEmitter();

  dossierStatus!: string;
  requestId!: string;
  documentsToShow: DocumentForDownloadModel[] = [];

  _actions!: DocumentActor[];
  set actions(v: DocumentActor[]) {
    this._actions = v;
  }
  masterToggle: boolean = true;
  selected: DocumentForDownloadModel[] = [];
  greeting!: string;
  date: string = "";
  /**
   * A count for whether NEW documents have been added to the request
   * if YES, just reget the download list
   */
  private currentDocumentCount = 0;
  private requestUpdatedSubscription: Subscription;

  constructor(public activeModal: NgbActiveModal, private viewerDataService: ViewerDataService, private viewerHubService: ViewerHubService, private downloadService: DownloadService, private documentApiClient: DocumentApiClient) {
    this.requestId = viewerDataService.get_RequestGuid;
    this.dossierStatus = viewerDataService.get_RequestStatus;
    this.actions = viewerDataService.userActors;
    this.getAndRefreshDocumentsToShow();

    this.requestUpdatedSubscription = this.viewerHubService.viewerRequest$.subscribe(request => {
      if (request && request.documentInfo) {
        if (this.currentDocumentCount < request.documentInfo.length) {
          this.getAndRefreshDocumentsToShow();
        }
      }
    });

  }
  ngOnDestroy(): void {
    if (this.requestUpdatedSubscription) {
      this.requestUpdatedSubscription.unsubscribe();
    }
  }
  private getAndRefreshDocumentsToShow() {
    this.documentApiClient.getForDownloadList(this.requestId).subscribe((data) => {
      this.documentsToShow = data;
      if (this.documentsToShow) {
        this.currentDocumentCount = this.documentsToShow.length;
      }
    });
  }
  get anyDocumentsSelected(): boolean {
    return this.documentsToShow && this.documentsToShow.some(x => x.isSelected);
  }

  downloadRequest() {
    var documentsToDownload = this.documentsToShow.filter(model => model.isSelected);
    this.downloadService.download(this.requestId, documentsToDownload);
  }

  toggleAll() {
    this.masterToggle = !this.masterToggle
    this.documentsToShow.forEach((doc) => {
      doc.isSelected = this.masterToggle;
    });
  }
  toggle(newModel: DocumentForDownloadModel) {
    newModel.isSelected = !newModel.isSelected;
    if (this.masterToggle)
      this.masterToggle = !this.masterToggle
  }
}
